import React from 'react';
import { useRouter } from 'next/router';

import InformationBlock from '../../../ui/InformationBlock/InformationBlock';

interface IProps {
  data: {
    background_image: string;
    button_icon?: string;
    button_text: string;
    description: string;
    icon?: string;
    id: number;
    title: string;
    type: string;
  };
}

export const ErrorBanner: React.FC<IProps> = ({ data }) => {
  const router = useRouter();
  return (
    <div className='section' itemScope itemType='https://schema.org/Alret'>
      <div className='wrapper'>
        <InformationBlock
          secondary={false}
          onClick={() => {
            router.push('/');
          }}
          content={{
            title: data?.title,
            text: data?.description,
            buttonText: data?.button_text,
          }}
          icon={''}
        />
      </div>
    </div>
  );
};
